import ApiService from '@/common/api.service'
import * as action from '@/store/action.types'
import * as mutation from '@/store/mutation.types'
import {
  GET_PAYMENT_STATUSES_URL,
  GET_COPARENTS_CHILDREN_URL,
  GET_ALL_EXPENSES,
  GET_ALL_RECURRING_EXPENSES,
  SPOUSAL_MAINTENANCE_ADD_NEW_URL,
  SPOUSAL_MAINTENANCE_LIST_URL,
  SPOUSAL_MAINTENANCE_FIND_BY_GUID_URL,
  SPOUSAL_MAINTENANCE_EDIT_URL,
  SPOUSAL_MAINTENANCE_SCHEDULED_ADD_NEW_URL,
  CHILD_MAINTENANCE_ADD_NEW_URL,
  CHILD_MAINTENANCE_LIST_URL,
  CHILD_MAINTENANCE_FIND_BY_GUID_URL,
  CHILD_MAINTENANCE_EDIT_URL,
  CHILD_MAINTENANCE_SCHEDULED_ADD_NEW_URL,
  DELETE_EXPENSE_URL,
  MARK_AS_PAID_URL,
  SHARED_EXPENSES_ADD_NEW_URL,
  SHARED_EXPENSES_LIST_URL,
  SHARED_EXPENSES_FIND_BY_GUID_URL,
  SHARED_EXPENSES_EDIT_URL,
  SHARED_EXPENSES_SCHEDULED_ADD_NEW_URL,
  PENDING_EXPENSES_LIST_URL,
  RECURRING_EXPENSES_LIST_URL,
  RECURRING_EXPENSES_DETAILS_URL,
  RECURRING_EXPENSES_DETAILS_SHARED_TABLE_URL,
  RECURRING_EXPENSES_DETAILS_TABLE_URL,
  DELETE_SCHEDULED_EXPENSE_URL,
  RECURRING_EXPENSE_FIND_BY_GUID_URL,
  RECURRING_EXPENSE_SM_UPDATE_URL,
  RECURRING_EXPENSE_CM_UPDATE_URL,
  RECURRING_EXPENSE_SE_UPDATE_URL,
  TRANSACTION_HISTORY_LIST_URL,
  GET_PAYMENTS_TYPES_URL
} from '@/constants/ApiConstants'

const state = {
  IS_PAYABLE_FROM: false
};

const getters = {
  IS_PAYABLE_FROM_GETTER: state => state.IS_PAYABLE_FROM
};

const actions = {
  [action.GET_COPARENTS_CHILDREN](_, guid) {
    return ApiService.get(GET_COPARENTS_CHILDREN_URL.replace(':coparentGuid', guid));
  },
  [action.GET_PAYMENT_STATUSES]() {
    return ApiService.get(GET_PAYMENT_STATUSES_URL);
  },
  [action.GET_ALL_EXPENSES]() {
    return ApiService.get(GET_ALL_EXPENSES);
  },
  [action.GET_ALL_RECURRING_EXPENSES]() {
    return ApiService.get(GET_ALL_RECURRING_EXPENSES);
  },
  [action.SPOUSAL_MAINTENANCE_ADD_NEW](_, data) {
    return ApiService.post(SPOUSAL_MAINTENANCE_ADD_NEW_URL, data);
  },
  [action.SPOUSAL_MAINTENANCE_LIST](_, data) {
    return ApiService.post(SPOUSAL_MAINTENANCE_LIST_URL.replace(':page', data.page).replace(':size', data.size), data);
  },
  [action.SPOUSAL_MAINTENANCE_FIND_BY_GUID](_, guid) {
    return ApiService.get(SPOUSAL_MAINTENANCE_FIND_BY_GUID_URL.replace(':guid', guid));
  },
  [action.SPOUSAL_MAINTENANCE_EDIT](_, data) {
    return ApiService.putData(SPOUSAL_MAINTENANCE_EDIT_URL, data);
  },
  [action.SPOUSAL_MAINTENANCE_SCHEDULED_ADD_NEW](_, data) {
    return ApiService.post(SPOUSAL_MAINTENANCE_SCHEDULED_ADD_NEW_URL, data);
  },
  [action.CHILD_MAINTENANCE_ADD_NEW](_, data) {
    return ApiService.post(CHILD_MAINTENANCE_ADD_NEW_URL, data);
  },
  [action.CHILD_MAINTENANCE_LIST](_, data) {
    return ApiService.post(CHILD_MAINTENANCE_LIST_URL.replace(':page', data.page).replace(':size', data.size), data);
  },
  [action.CHILD_MAINTENANCE_FIND_BY_GUID](_, guid) {
    return ApiService.get(CHILD_MAINTENANCE_FIND_BY_GUID_URL.replace(':guid', guid));
  },
  [action.CHILD_MAINTENANCE_EDIT](_, data) {
    return ApiService.putData(CHILD_MAINTENANCE_EDIT_URL, data);
  },
  [action.CHILD_MAINTENANCE_SCHEDULED_ADD_NEW](_, data) {
    return ApiService.post(CHILD_MAINTENANCE_SCHEDULED_ADD_NEW_URL, data);
  },
  [action.DELETE_EXPENSE](_, guid) {
    return ApiService.delete(DELETE_EXPENSE_URL.replace(':guid', guid));
  },
  [action.SHARED_EXPENSES_ADD_NEW](_, data) {
    return ApiService.post(SHARED_EXPENSES_ADD_NEW_URL, data);
  },
  [action.SHARED_EXPENSES_LIST](_, data) {
    return ApiService.post(SHARED_EXPENSES_LIST_URL.replace(':page', data.page).replace(':size', data.size), data);
  },
  [action.SHARED_EXPENSES_FIND_BY_GUID](_, guid) {
    return ApiService.get(SHARED_EXPENSES_FIND_BY_GUID_URL.replace(':guid', guid));
  },
  [action.SHARED_EXPENSES_EDIT](_, data) {
    return ApiService.putData(SHARED_EXPENSES_EDIT_URL, data);
  },
  [action.SHARED_EXPENSES_SCHEDULED_ADD_NEW](_, data) {
    return ApiService.post(SHARED_EXPENSES_SCHEDULED_ADD_NEW_URL, data);
  },
  [action.PENDING_EXPENSES_LIST](_, data) {
    return ApiService.post(PENDING_EXPENSES_LIST_URL.replace(':page', data.page).replace(':size', data.size), data);
  },
  [action.RECURRING_EXPENSES_LIST](_, data) {
    return ApiService.post(RECURRING_EXPENSES_LIST_URL.replace(':page', data.page).replace(':size', data.size), data);
  },
  [action.RECURRING_EXPENSES_DETAILS](_, data) {
    return ApiService.get(RECURRING_EXPENSES_DETAILS_URL.replace(':guid', data.guid));
  },
  [action.RECURRING_EXPENSES_DETAILS_TABLE](_, data) {
    return ApiService.post(RECURRING_EXPENSES_DETAILS_TABLE_URL.replace(':guid', data.guid).replace(':page', data.page).replace(':size', data.size).replace(':sort', data.sort), data);
  },
  [action.RECURRING_EXPENSES_DETAILS_SHARED_TABLE](_, data) {
    return ApiService.post(RECURRING_EXPENSES_DETAILS_SHARED_TABLE_URL.replace(':guid', data.guid).replace(':page', data.page).replace(':size', data.size).replace(':sort', data.sort), data);
  },
  [action.RECURRING_DELETE_SCHEDULED_EXPENSE](_, guid) {
    return ApiService.delete(DELETE_SCHEDULED_EXPENSE_URL.replace(':guid', guid));
  },
  [action.RECURRING_EXPENSE_FIND_BY_GUID](_, guid) {
    return ApiService.get(RECURRING_EXPENSE_FIND_BY_GUID_URL.replace(':guid', guid));
  },
  [action.RECURRING_EXPENSE_SM_UPDATE](_, data) {
    return ApiService.putData(RECURRING_EXPENSE_SM_UPDATE_URL, data);
  },
  [action.RECURRING_EXPENSE_CM_UPDATE](_, data) {
    return ApiService.putData(RECURRING_EXPENSE_CM_UPDATE_URL, data);
  },
  [action.RECURRING_EXPENSE_SE_UPDATE](_, data) {
    return ApiService.putData(RECURRING_EXPENSE_SE_UPDATE_URL, data);
  },
  [action.TRANSACTION_HISTORY_LIST](_, data) {
    return ApiService.post(TRANSACTION_HISTORY_LIST_URL.replace(':page', data.page).replace(':size', data.size), data);
  },
  [action.MARK_AS_PAID](_, guid) {
    return ApiService.post(MARK_AS_PAID_URL.replace(':guid', guid));
  },
  [action.GET_PAYMENTS_TYPES]() {
    return ApiService.get(GET_PAYMENTS_TYPES_URL);
  },
  [action.GET_PAYABLE_FROM] ({ commit }, data) {
    commit(mutation.SET_PAYABLE_FROM, data)
  }
};

const mutations = {
  [mutation.SET_PAYABLE_FROM] (state, actionPayload) {
    state.IS_PAYABLE_FROM = actionPayload
  }
};

export default {
  state,
  actions,
  getters,
  mutations
}
